import * as React from 'react';
import { ReactComponent as EgptLogo } from 'src/assets/tailwind/empowergpt-logo.svg';
import { ReactComponent as ELogo } from 'src/assets/tailwind/Logo.svg';
import { Button } from 'src/components/ui/button';
import { Icon } from 'src/components/ui/icon';
import { sidebarIcons } from 'src/layouts/SidebarV2/icons';

export interface FooterProps {
  collapsed?: boolean;
  hasUnread?: boolean;
  notification?: React.ReactNode;
  onBellClick?: () => void;
}

const BellButton = ({
  hasUnread,
  onClick
}: {
  hasUnread?: boolean;
  onClick?: () => void;
}) => (
  <div className="tw:relative tw:shrink-0">
    <Button
      hierarchy="ghost"
      iconOnly
      leftIcon={sidebarIcons.bell}
      onClick={onClick}
      aria-label="Notifications"
    />
    {hasUnread ? (
      <span className="tw:absolute tw:top-1 tw:right-1 tw:w-2 tw:h-2 tw:rounded-full tw:bg-brand tw:border-1 tw:border-solid tw:border-main" />
    ) : null}
  </div>
);

const Footer = ({
  collapsed = false,
  hasUnread = false,
  notification,
  onBellClick
}: FooterProps) => {
  const bell = notification ?? (
    <BellButton hasUnread={hasUnread} onClick={onBellClick} />
  );

  return collapsed ? (
    <div className="tw:flex tw:flex-col tw:items-center tw:gap-s tw:w-full">
      {bell}
      <Icon
        icon={ELogo}
        sizeClass="tw:w-2-5xl tw:h-2-5xl"
        colorClass="tw:text-logo-brand"
      />
    </div>
  ) : (
    <div className="tw:flex tw:items-center tw:justify-between tw:w-full tw:pb-s">
      <EgptLogo className="tw:h-3xl tw:w-auto tw:shrink-0" />
      {bell}
    </div>
  );
};

export { Footer };
